import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useProfileContext } from '../ProfileContext';
import { OTTO_PROFILE_STEPS } from '../enums';
import { hasValidSummary } from '../utils';
import AddressForm from './AddressForm';
import PetAndCustomerForm from './PetAndCustomerForm';
import SummaryForm from './SummaryForm';
/**
 * User should only be able to access address route if their contact and pet info is saved.
 */
var ValidAddressRoute = function (_a) {
    var children = _a.children;
    var navigate = useNavigate();
    var _b = useProfileContext(), profileData = _b.profileData, profileBasePath = _b.profileBasePath;
    useEffect(function () {
        if (profileData.pets.length < 1 || !profileData.customerName || !profileData.email) {
            console.error('Incomplete profile. Redirecting...');
            navigate(profileBasePath, { replace: true, viewTransition: true });
        }
    }, [profileData, navigate]);
    if (profileData.pets.length < 1 || !profileData.customerName || !profileData.email) {
        return null;
    }
    return _jsx(_Fragment, { children: children });
};
/**
 * User should only be able to access summary route if their pet has a name and weight
 * and we have their address saved (which assumes that contact info is also saved).
 */
var ValidSummaryRoute = function (_a) {
    var children = _a.children;
    var navigate = useNavigate();
    var _b = useProfileContext(), profileData = _b.profileData, profileBasePath = _b.profileBasePath;
    useEffect(function () {
        if (!hasValidSummary(profileData)) {
            console.error('Incomplete profile. Redirecting...');
            navigate(profileBasePath, { replace: true, viewTransition: true });
        }
    }, [profileData, navigate]);
    if (!hasValidSummary(profileData)) {
        return null;
    }
    return _jsx(_Fragment, { children: children });
};
var OneTimeSamplerPackProfileRoutes = [
    {
        index: true,
        loader: function () { return OTTO_PROFILE_STEPS.petAndCustomerForm; },
        element: _jsx(PetAndCustomerForm, {}),
    },
    {
        path: 'address',
        loader: function () { return OTTO_PROFILE_STEPS.addressForm; },
        element: (_jsx(ValidAddressRoute, { children: _jsx(AddressForm, {}) })),
    },
    {
        path: 'summary',
        loader: function () { return OTTO_PROFILE_STEPS.summaryForm; },
        element: (_jsx(ValidSummaryRoute, { children: _jsx(SummaryForm, {}) })),
    },
];
export default OneTimeSamplerPackProfileRoutes;
